import { customerApiClient } from './customer-api-client';
import type { CustomerRequestThread } from '@/types/customer-request-thread.types';

/**
 * Stage D-i (D-145 / OD-D1) — the customer Request Thread route.
 *
 * One call, no client-side authorization. The round is resolved server-side
 * through the D-130 scoped job, and a round that is absent, another customer's,
 * another tenant's or outside this contact's location scope all answer with the
 * same 404 — so there is nothing here to check, and checking anything would
 * make the frontend a second authorization system.
 */
export const customerRequestThreadService = {
  /** The request thread for one modification round. */
  getByRoundId: (roundId: string): Promise<CustomerRequestThread> =>
    customerApiClient
      .get<CustomerRequestThread>(`/customer-portal/requests/${roundId}`)
      .then((r) => r.data),
};
